import type { FC, PropsWithChildren } from 'react'
import { cn } from '@/utils'

type MentionSuggestionsWidgetProps = {
  className?: string
}

export const TiptapSuggestionsWidget: FC<
  PropsWithChildren<MentionSuggestionsWidgetProps>
> = ({ className, children }) => {
  return (
    <div
      className={cn(
        'rounded w-max overflow-hidden shadow-lg border border-white/10 bg-black/10 bg-clip-padding backdrop-blur-lg',
        className,
      )}
    >
      {children}
    </div>
  )
}
